export default __webpack_public_path__ + "static/media/mobile-write-icon.148dfd6d.svg";